import reactApp from "./reactApp";
import WishList from "./WishList";
import DocumentElement from "../utils/Page";
import { BoxSize } from "./reactApp/src/Types";
import { GlobalToastProps } from "../utils/GlobalToast";
import NoticesWrapper from "./NoticesWrapper";

interface ExtraProduct {
  title: string;
  thumbnail: string;
  description: string;
}

export interface ModuleColors {
  background_color: string;
  text_color: string;
  preset_name: string;
}
interface InitialDataProps {
  TRANSLATIONS: any;
  postId: any;
  LANGUAGE: string;
  COLORS: ModuleColors[] | null;
  extraProduct: ExtraProduct;
}

interface WoocommerceParams {
  ajax_url: string;
  wc_ajax_url: string;
}

declare global {
  interface Window {
    basePath: string;
    INITIAL_DATA: InitialDataProps;
    Cookies: any;
    canvasRef: fabric.Canvas;
    canvasWrapRef: HTMLElement;
    scaledCanvasSize: BoxSize;
    jQuery: JQuery;
    woocommerce_params: WoocommerceParams;
    globalToast: (props: GlobalToastProps) => void;
    FB: any;
    instagramAuthenticationCheck: () => void;
  }
}

export default {
  ...reactApp,
  WishList,
  DocumentElement,
  NoticesWrapper,
};
